const VISITOR_ID_COOKIE = 'JobseekerVisitorId';
const SESSION_ID_COOKIE = 'JobseekerSessionId';
const VISITOR_ID_HEADER = 'X-Seek-EC-VisitorId';
const SESSION_ID_HEADER = 'X-Seek-EC-SessionId';
const cookieString = typeof document !== 'undefined' ? document.cookie : '';
export default (cookies = cookieString) => cookies
    .replace(VISITOR_ID_COOKIE, VISITOR_ID_HEADER)
    .replace(SESSION_ID_COOKIE, SESSION_ID_HEADER)
    .split(';')
    .filter((value) => value.includes(VISITOR_ID_HEADER) || value.includes(SESSION_ID_HEADER))
    .reduce((sum, cookie) => {
    const [key, value] = cookie.split('=');
    return Object.assign(Object.assign({}, sum), (key && value ? { [key.trim()]: value.trim() } : {}));
}, {});
//# sourceMappingURL=getTrackingHeaders.js.map